<template>
  <CSSVGIcon
    iconName="careship-logo"
    classes="logo__careship"
    class="sidenav-logo"
  />
</template>

<script>
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'

export default {
  name: 'CSCareshipLogo',
  components: { CSSVGIcon },
}
</script>
